export default {
  colors: {
    primary: '#4589FF',
    surface: '#FFFFFF',
    accent: '#4589FF',
    'accent-selection-background': '#E4EBF7',
    'accent-text': '#FFFFFF',
    'canvas-actions': '#FAFAFB',
    'canvas-background': '#E4E5E9',
    'canvas-edit-outline': '#2973F3',
    'canvas-outline': '#E4E7EE',
    'navigation-background': '#FFFFFF',
    'panel-background-secondary': '#FAFAFC',
    'panel-background-tertiary': '#D8DADE',
    'panel-background': '#F1F2F5',
    'panel-outline': '#D6D9DF',
    'text-canvas-primary': '#1D1D1F',
    'text-canvas-secondary': '#8C8D91',
    'text-navigation-primary': '#1C1C1D',
    'text-navigation-secondary': '#56575A',
    'text-panel-primary': '#161718',
    'text-panel-secondary': '#454547',
    'text-panel-tertiary': '#373839'
  }
}
